import WelcomeSection from "./WelcomeSection";
import AboutUs from "./AboutUs";
import ContactSection from "./ContactSection";
import TermsAndConditions from "./TermsAndConditions";
import PrivacyPolicy from "./PrivacyPolicy";
import React from "react";
import FeaturesSection from "./FeaturesSection";
import styles from './MainPage.module.scss';

const MainPage: React.FC = () => {
    return <div className={styles.overBackground}>
        <WelcomeSection/>
        <FeaturesSection/>
        <AboutUs/>
        <br/>
        <ContactSection/>
        <br/>
        <TermsAndConditions/>
        <PrivacyPolicy/>
    </div>
}

export default MainPage;